module.exports = __webpack_public_path__ + "static/img/jiaying-fail.375afdb2.png";